import { useContext } from 'react'
import useUser from '../../../../contexts/hooks/useUser'
import { ObjectContext } from '../../../../contexts/objectContext/ObjectContext'
import { trpc } from '../../../../modules/trpc'

export const useChargingLocations = () => {
	const object = useContext(ObjectContext)
	const utils = trpc.useContext()

	const { user } = useUser()

	// Get charging locations
	const { data: chargingLocations, isLoading } = trpc.eNode.charging.stations.get.useQuery(
		{ hashedPid: user?.hashedPid ?? '' },
		{ enabled: Boolean(user?.hashedPid) }
	)

	// Delete charging location
	const deleteMutation = trpc.eNode.charging.stations.delete.useMutation({
		onSuccess: () => {
			utils.eNode.charging.stations.invalidate()
		},
	})

	// Edit object with charging location
	const objectMutation = trpc.objects.edit.useMutation({
		onSuccess: () => {
			utils.user.getObjects.invalidate()
		},
	})

	// Get vehicles
	const { data: vehicles, isLoading: vehiclesLoading } = trpc.eNode.vehicles.get.useQuery(
		{
			hashedPid: user?.hashedPid ?? '',
		},
		{ enabled: Boolean(user?.hashedPid) }
	)

	const invalidateChargingStations = () => {
		utils.eNode.charging.stations.invalidate()
	}

	const deleteChargingLocation = (stationId: string) => {
		if (user?.hashedPid) {
			deleteMutation.mutate({ hashedPid: user.hashedPid, stationId })
		}
	}

	const updateObjectChargingLocation = (locationId: string | null) => {
		objectMutation.mutate({
			id: object.id,
			data: {
				chargingLocationId: locationId,
			},
		})
	}

	return {
		object,
		chargingLocations,
		isLoading,
		vehicles,
		vehiclesLoading,
		invalidateChargingStations,
		deleteChargingLocation,
		updateObjectChargingLocation,
	}
}
